"use client";

import { useContent } from "@/hooks/useContent";
import type { Bilingual, Locale } from "@/types/calculator";
import { useLocale } from "next-intl";

interface CalcContent { title: Bilingual; subtitle: Bilingual }

/** Calculator page header, driven by panel-managed content. */
export default function CalcHeader() {
  const locale = useLocale() as Locale;
  const ar = locale === "ar";
  const { data } = useContent<CalcContent>("calculator");

  return (
    <header className="mx-auto max-w-360 border-b border-black/10 px-6 pb-8 pt-24 lg:px-10 dark:border-white/10">
      <span className="text-[11px] uppercase tracking-widest text-accent">{ar ? "خطط بثقة" : "Plan with confidence"}</span>
      <h1 className="mt-2 font-bebas text-[clamp(2.5rem,6vw,5rem)] uppercase leading-none text-ash dark:text-white">
        {data?.title?.[locale] ?? (ar ? "احسب خطتك" : "Calculate Your Plan")}
      </h1>
      {data?.subtitle && (
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-ash/60 dark:text-white/60">{data.subtitle[locale]}</p>
      )}
    </header>
  );
}
